import React from 'react'
import styled from 'styled-components'

import { IconButton } from 'adl'

const AnnouncementBG = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.colors.warning};
  padding: 8px 40px;
  text-align: center;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  z-index: 999;
`

export default ({ message, visible, onHide }) => {
  if (!visible) {
    return null
  }

  return (
    <AnnouncementBG visible={visible}>
      {message}
      <IconButton
        style={{ position: 'absolute', top: 2, right: 8, fontSize: 16 }}
        onClick={onHide}
        iconColor="white"
      >
        <i className="icon-close" />
      </IconButton>
    </AnnouncementBG>
  )
}
